import {
    EnvironmentProviders,
    Provider,
    inject,
    provideEnvironmentInitializer,
} from '@angular/core';
import { AuthAppService } from '@modules/auth';

// L'authInterceptor est enregistré dans app.config.ts (provideHttpClient) pour garantir
// un ordre d'interception explicite et éviter un double appel provideHttpClient.
export const provideAuth = (): (Provider | EnvironmentProviders)[] => {
    return [
        provideEnvironmentInitializer(() => inject(AuthAppService)),
    ];
};
